import React, { useEffect, useState } from "react";
import { checkoutSession, getPackages } from "../../services/api/packages";
import { PackagesResponse } from "../LandingPage";
import { useGlobalContext } from "../../context/GlobalContext";
import { useToastContext } from "../../context/ToastContext";
import PricingPackage from "../../components/PricingPackageLandingPage";

const PricingSection: React.FC = () => {
    const [packages, setPackages] = useState<PackagesResponse[]>([]);
    const { showToast } = useToastContext()
    const { user, setIsLoading, isLoading } = useGlobalContext()

    useEffect(() => {

        const fetchPackages = async () => {
            let packages = await getPackages();
            setPackages(packages.data);
        };
        fetchPackages();
        // eslint-disable-next-line
    }, []);
    const packageHandler = async (index: number) => {
        setIsLoading(true)
        const baseURL = window.location.origin;
        if (index !== 0) {
            let res = await checkoutSession({
                customerEmail: user?.user?.email,
                successUrl: `${baseURL}/thank-you`,
                cancelUrl: `${baseURL}/login`,
            });
            if (!res.url.success) {
                showToast(res?.url?.data, "error")
            } else {
                window.location.href = res.url.data
            }
        } else {
            window.location.href = "/dashboard"
        }
        setIsLoading(false)
    }
    return (
        <>
            <PricingPackage
                packages={packages}
                packageHandler={packageHandler}
                isLoading={isLoading}
            />
        </>
    );
};

export default PricingSection;
